module.exports = __webpack_public_path__ + "img/zx_cup.a9928446.png";